namespace Matrix.Indexation {
    export interface FactIndexationProfileSecurityRow {
        IndexationProfileKey?: number;
        SecurityKey?: number;
        IndexKey?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
        SecuritySecurityId?: number;
        SecurityName?: string;
        SecurityGeneration?: number;
        SecurityIsCurrent?: string;
        SecurityEffectiveFrom?: string;
        SecurityEffectiveTo?: string;
        SecurityRowId?: number;
        IndexCode?: string;
        IndexName?: string;
        IndexGeneration?: number;
        IndexIsCurrent?: string;
        IndexEffectiveFrom?: string;
        IndexEffectiveTo?: string;
        IndexLocalCurrencyCode?: string;
        IndexTypeCode?: string;
        IndexPriceSource1?: string;
        IndexPriceSource1Id?: string;
        IndexPriceSource2?: string;
        IndexPriceSource2Id?: string;
        IndexFxOtherCurrency?: string;
        IndexRowId?: number;
    }

    export namespace FactIndexationProfileSecurityRow {
        export const idProperty = 'IndexationProfileKey';
        export const localTextPrefix = 'Indexation.FactIndexationProfileSecurity';
        export const deletePermission = 'DataAdmin:FactIndexationProfileSecurity';
        export const insertPermission = 'DataAdmin:FactIndexationProfileSecurity';
        export const readPermission = 'Read:FactIndexationProfileSecurity';
        export const updatePermission = 'DataAdmin:FactIndexationProfileSecurity';

        export declare const enum Fields {
            IndexationProfileKey = "IndexationProfileKey",
            SecurityKey = "SecurityKey",
            IndexKey = "IndexKey",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder",
            SecuritySecurityId = "SecuritySecurityId",
            SecurityName = "SecurityName",
            SecurityGeneration = "SecurityGeneration",
            SecurityIsCurrent = "SecurityIsCurrent",
            SecurityEffectiveFrom = "SecurityEffectiveFrom",
            SecurityEffectiveTo = "SecurityEffectiveTo",
            SecurityRowId = "SecurityRowId",
            IndexCode = "IndexCode",
            IndexName = "IndexName",
            IndexGeneration = "IndexGeneration",
            IndexIsCurrent = "IndexIsCurrent",
            IndexEffectiveFrom = "IndexEffectiveFrom",
            IndexEffectiveTo = "IndexEffectiveTo",
            IndexLocalCurrencyCode = "IndexLocalCurrencyCode",
            IndexTypeCode = "IndexTypeCode",
            IndexPriceSource1 = "IndexPriceSource1",
            IndexPriceSource1Id = "IndexPriceSource1Id",
            IndexPriceSource2 = "IndexPriceSource2",
            IndexPriceSource2Id = "IndexPriceSource2Id",
            IndexFxOtherCurrency = "IndexFxOtherCurrency",
            IndexRowId = "IndexRowId"
        }
    }
}
